var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<ul class=\"nav nav-tabs hide-in-print\">\n<li ng-repeat=\"tab in $ctrl.tabs\" role=\"presentation\" ui-sref-active=\"active\" ui-sref=\"{{tab.state}}\" ng-show=\"::$ctrl.hasAcl(tab.key)\">\n<a class=\"branch-mgmt-badge\">\n{{tab.title | translate}}\n</a>\n</li>\n</ul>\n<div class=\"remove-pad\">\n<div class=\"mt-20\">\n<ui-view></ui-view>\n</div>\n</div>\n</div>";
var id1="tnt_control.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./client/app/components/tnt_control/tnt_control.html
// module id = 2877
// module chunks = 1